import React from 'react';
import moment from 'moment';
import { BarChart, Bar, XAxis, YAxis } from 'recharts';
import { IRNSummaryDetails } from '../../../common/types';
import { formatInvoices } from '../../utils/formatInvoices';

interface BarChartProps {
  barData: Map<string, IRNSummaryDetails>;
  fromDate: string;
  toDate: string;
  range: string | null;
}

const Barchart: React.FC<BarChartProps> = ({
  barData,
  fromDate,
  toDate,
  range,
}) => {

  const totalBarData: any = [];
  const barDatesArray: any = [];
  let fromDateValue = fromDate;

  barData.forEach((key: any, value: any) => {
    const arrayItem = moment(value, 'DD/MM/YYYY').format('DD/MM/YYYY');
    barDatesArray.push(arrayItem);
  });

  let days =
    moment(toDate, 'YYYY-MM-DD HH:mm:ss').diff(
      moment(fromDate, 'YYYY-MM-DD HH:mm:ss'),
      'days'
    ) + 1;

  while (days) {
    const checkDate = moment(fromDateValue, 'YYYY-MM-DD HH:mm:ss').format(
      'DD/MM/YYYY'
    );
    if (barDatesArray.indexOf(checkDate) !== -1) {
      const tempData = {
        name: moment(checkDate, 'DD/MM/YYYY').format('DD/MM'),
        failed: barData.get(checkDate)?.totalIrnFailed || 0,
        cancelled: barData.get(checkDate)?.totalIrnCancelled || 0,
        pending: barData.get(checkDate)?.totalPendingIrnGeneration || 0,
        generated: barData.get(checkDate)?.totalIrnGenerated || 0,
        totalNumber: 
          barData.get(checkDate)?.totalNoOfInvoices || 0,
      };
      totalBarData.push(tempData);
    } else {
      const tempData = {
        name: moment(checkDate, 'DD/MM/YYYY').format('DD/MM'),
        failed: 0,
        cancelled: 0,
        pending: 0,
        generated: 0,
      };
      totalBarData.push(tempData);
    }

    fromDateValue = moment(fromDateValue, 'YYYY-MM-DD HH:mm:ss')
      .add(1, 'days')
      .format('YYYY-MM-DD HH:mm:ss');
    days -= 1;
  }

  return (
    <BarChart
      width={range === 'MONTH' ? 1000 : 390}
      height={143}
      data={totalBarData}
      barCategoryGap={26}
      margin={{
        top: 0,
        right: 0,
        left: -10,
        bottom: 0,
      }}
    >
      <XAxis
        dataKey="name"
        fontFamily="Nunito"
        fontWeight="400"
        fontSize="12px"
        overflow="scroll"
      />
      <YAxis 
        fontFamily="Nunito"
        fontWeight="400"
        fontSize="12px"
        tickFormatter={(label) => `${formatInvoices(label,0)}`}/>
      <Bar barSize={26} dataKey="failed" stackId="a" fill="#E55E5E" />
      <Bar barSize={26} dataKey="cancelled" stackId="a" fill="#F58D2A" />
      <Bar barSize={26} dataKey="pending" stackId="a" fill="#EECE33" />
      <Bar barSize={26} dataKey="generated" stackId="a" fill="#50CB65" radius={[5,5,0,0]}/>
    </BarChart>
  );
};

export default Barchart;
